import type {
  DatabricksWorkspaceAuth,
  DatabricksWorkspaceEntry,
} from "./DatabricksWorkspacesIntegrationForm.types";

export const isDatabricksUrl = (url: string) => url.trim().startsWith("https://");

export const isDatabricksAuthComplete = (auth: DatabricksWorkspaceAuth) =>
  auth.auth_type === "oauth_m2m"
    ? !!auth.client_id?.trim() && !!auth.client_secret
    : !!auth.personal_access_token;

export const canSaveDatabricks = (entry: DatabricksWorkspaceEntry) =>
  isDatabricksUrl(entry.url) && isDatabricksAuthComplete(entry.auth);
